import { ICategory } from '../models';

export const getCategoryBySlug = (
  categories: ICategory[],
  slug: string[]
): ICategory | null => {
  if (!slug) {
    return null;
  }
  let category = null;
  while (slug.length > 0) {
    category = categories.find(c => c.slug === slug[0]) || null;
    slug.shift();
    if (category && slug.length > 0 && category.children) {
      category = getCategoryBySlug(category.children, slug);
    }
  }
  return category;
};

export const getHighlightedCategories = (
  categories: ICategory[]
): ICategory[] => {
  const highlighted: ICategory[] = [];

  const recursiveFilter = (categories: ICategory[]): ICategory[] => {
    if (!categories.length) return highlighted;

    categories.forEach(category => {
      if (category.highlight) {
        highlighted.push(category);
      }
    });

    return recursiveFilter(
      categories.map(category => category.children).flat()
    );
  };

  return recursiveFilter(categories).slice(0, 2);
};

export const getFullCategoryPathFromId = (
  categories: ICategory[],
  id: string | number
): string => {
  const pathTo = (categories: ICategory[], id: string | number) => {
    let result = '';

    (categories || []).forEach(category => {
      if (category.id_category === id) {
        return (result = category.slug);
      }

      const nestedPath = pathTo(category.children, id);

      if (nestedPath) {
        result = `${category.slug}/${nestedPath}`;
        return;
      }
    });

    return result;
  };

  return 'shop/' + pathTo(categories, id);
};

export const getCategoryNameByPaths = (
  categories: ICategory[],
  slugs: string[]
): ICategory | undefined => {
  let category: ICategory | undefined;

  for (let i = 0; i < slugs.length; i++) {
    if (category) {
      category = category.children.find(c => c.slug === slugs[i]);
      continue;
    }

    category = categories.find(c => c.slug === slugs[i]);
  }
  return category;
};

export const SIZES_ORDER = {
  XXS: 0,
  XS: 2,
  S: 4,
  M: 6,
  L: 8,
  XL: 10,
  XXL: 12,
  XXXL: 14
} as { [key: string]: number };
